import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import {
    getSelectedOfferingCode,
    getTransferExistingOrganizationNumber,
} from "../../../../checkout/state/selectors/accountSelectors";
import TEXT from "../../../text-consts";

interface SummaryContinueButtonProps {
    isDisabled: boolean;
    url: string;
}

const SummaryContinueButton: React.FC<SummaryContinueButtonProps> = ({
    url,
    // Redux (data)
    isDisabled,
}) => (
    <Button
        id="summary-continue-button"
        disabled={isDisabled}
        onClick={() => window.location.assign(url)}
        type="submit"
    >
        {TEXT.COMMON.CONTINUE}
    </Button>
);

const mapStateToProps = (state: RootState) => ({
    isDisabled: !getSelectedOfferingCode(state) && !!getTransferExistingOrganizationNumber(state),
});

export default connect(mapStateToProps)(SummaryContinueButton);
